import React from 'react'
import Header from '../common/header/header'
import Footer from '../common/footer/footer'
import '../login/login.css'


class Recoveruername extends React.Component{
    constructor(props)
    {
        super(props)
        this.state ={
            email : ""
        }
    }
    componentDidMount(){
        document.title = "IDrive® Compute | Recover username"
        // const link = document.createElement("link")
        // link.href = "/webapp/css/login-page.css"
        // link.rel = "stylesheet"
        // link.type = "text/css"
        // document.head.appendChild(link)

        // const link1 = document.createElement("link")
        // link1.href = "/webapp/css/static-common.css"
        // link1.rel = "stylesheet"
        // link1.type = "text/css"
        // document.head.appendChild(link1)
    }
    handleInput(event){
        let val = event.target.value

        this.setState({
            email : val
        })
    }
    submitForm(){
        alert("The Email you provided"+this.state.email)
    }
    render(){
        return(
          <div>
              <Header />
            <div className="body_inner">
                <main className="static">
                    <div id="static_form_wrap">
                        <div className="sign_in_bg"></div>
                        <div className="wrapper">
                            <div className="box_center_align">
                                <form id="signin-form" onSubmit = {this.submitForm}>
                                    <div className="box_header_text">
                                        <h1>Recover Username</h1>
                                    </div>
                                    <div className="box_inner_wrap">
                                        <div className="msg_box">
                                            <div className="common_msg success ">
                                                <div className="info"> <strong>Success</strong><br></br>
                                                An email has been sent to your registered email address. </div>
                                            </div>
                                        </div>
                                        <div className="msg_box">
                                            <div className="common_msg error">
                                                <div className="info">Username is invalid</div>
                                            </div>
                                        </div>
                                        <div className="forgot_pwd">
                                            <p className="frget_alert">A link to recover the username for your account will be sent to the email address.</p>
                                            <div className="inp_row">
                                                <label>Email</label>
                                                <input type="text" name="email"  className="txt-box" onChange = {this.handleInput}></input>
                                                <span className="error_msg" style = {{display: "none"}} >The field cannot be blank</span> 
                                            </div>
                                            <div className="fp_reCaptcha"> 
                                                <div className="clear"></div>
                                                    <label htmlFor="catpcha-block" style={{display: "none"}}>captcha</label>
                                                    <div className="g-recaptcha" id="catpcha-block" data-sitekey="6Ldc3SETAAAAALIrVtWVeWVROIj5TwPseUYL7XIY"></div>
                                                    <span className="red txterror" id="captcha_err"></span>
                                            </div>
                                            <div className="footer_wrap"> 
                                                <input type="submit" name="" value="Recover Username" className="btn-primary"  data-sitekey="6LfvAiwUAAAAANov16A_dcQhR952_39cma0Itaof" data-callback="onSubmit" data-size="invisible"></input>
                                            </div>
                                            <div className="pwd_forget"><a href="forgot-password">Forgot your Password?</a></div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </main>
                <div className="clear"></div>
                <Footer/>
                </div>
            </div>
        ) 
    }
}

export default Recoveruername